import { call, put, takeEvery } from 'redux-saga/effects'

import { sendAuthenticatedGetRequestToAPI } from 'modules/generators/requestsToAPI'
import { setFormInput } from 'user/pages/Form/module'

export const GET_CUSTOMER_FILE_REQUEST = 'MurfyPage/GET_CUSTOMER_FILE_REQUEST'
export const GET_CUSTOMER_FILE_SUCCESS = 'MurfyPage/GET_CUSTOMER_FILE_SUCCESS'
export const GET_CUSTOMER_FILE_ERROR = 'MurfyPage/GET_CUSTOMER_FILE_ERROR'
export const SET_VISIT_ID = 'MurfyPage/SET_VISIT_ID'

export function getCustomerFileRequest (customerFileId) {
  return {
    type: GET_CUSTOMER_FILE_REQUEST,
    payload: customerFileId
  }
}

export function getCustomerFileSuccess (customerFile) {
  return {
    type: GET_CUSTOMER_FILE_SUCCESS,
    payload: customerFile
  }
}

export function getCustomerFileError (error) {
  return {
    type: GET_CUSTOMER_FILE_ERROR,
    payload: error
  }
}

export function setVisitIdRequest (visit) {
  return {
    type: SET_VISIT_ID,
    payload: visit
  }
}

export function * getCustomerFile (action) {
  const customerFileId = action.payload
  const route = `/murfy-erp/customer-file/${customerFileId}/`

  yield call(
    sendAuthenticatedGetRequestToAPI,
    route,
    getCustomerFileSuccess,
    getCustomerFileError
  )
}

export function * setCustomerFileFormInput (action) {
  yield put(setFormInput('text', 'firstname', action.payload.firstname, -3))
  yield put(setFormInput('text', 'lastname', action.payload.lastname, -2))
  yield put(setFormInput('mail', 'email', action.payload.email, -1))
}

export function * setVisitIdFormInput (action) {
  yield put(setFormInput('text', 'visit', action.payload, -4))
}

export function * getCustomerFileSaga () {
  yield takeEvery(GET_CUSTOMER_FILE_REQUEST, getCustomerFile)
}

export function * getCustomerFileSuccessSaga () {
  yield takeEvery(GET_CUSTOMER_FILE_SUCCESS, setCustomerFileFormInput)
}

export function * setVisitIdSaga () {
  yield takeEvery(SET_VISIT_ID, setVisitIdFormInput)
}
/**
 * Following the duck pattern, the module.js file should export a reducer as a default function
 */

const initialState = {
  error: null,
  customerFile: null
}

export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_CUSTOMER_FILE_REQUEST:
      return {
        ...state,
        error: null
      }
    case GET_CUSTOMER_FILE_SUCCESS:
      return {
        ...state,
        customerFile: action.payload,
        error: null
      }
    case GET_CUSTOMER_FILE_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default reducer
